
import { WorldCountry } from '../types';
import { unitedStatesAdditionalCities } from './unitedStatesExpansion';
import { unitedStatesAdditionalCities2 } from './unitedStatesExpansion2';
import { unitedStatesAdditionalCities3 } from './unitedStatesExpansion3';

export const unitedStatesData: WorldCountry = {
  name: 'United States',
  slug: 'united-states',
  code: 'US',
  population: 331002651,
  topCities: [
    { name: 'New York', slug: 'new-york', population: 8336817 },
    { name: 'Los Angeles', slug: 'los-angeles', population: 3979576 },
    { name: 'Chicago', slug: 'chicago', population: 2693976 },
    { name: 'Houston', slug: 'houston', population: 2320268 },
    { name: 'Phoenix', slug: 'phoenix', population: 1680992 },
    { name: 'Philadelphia', slug: 'philadelphia', population: 1584064 },
    { name: 'San Antonio', slug: 'san-antonio', population: 1547253 },
    { name: 'San Diego', slug: 'san-diego', population: 1423851 },
    { name: 'Dallas', slug: 'dallas', population: 1343573 },
    { name: 'San Jose', slug: 'san-jose', population: 1021795 },
    { name: 'Austin', slug: 'austin', population: 978908 },
    { name: 'Jacksonville', slug: 'jacksonville', population: 949611 },
    { name: 'Fort Worth', slug: 'fort-worth', population: 918915 },
    { name: 'Columbus', slug: 'columbus', population: 905748 },
    { name: 'Indianapolis', slug: 'indianapolis', population: 876384 },
    { name: 'Charlotte', slug: 'charlotte', population: 885708 },
    { name: 'San Francisco', slug: 'san-francisco', population: 881549 },
    { name: 'Seattle', slug: 'seattle', population: 769714 },
    { name: 'Denver', slug: 'denver', population: 715522 },
    { name: 'Washington', slug: 'washington-dc', population: 689545 },
    { name: 'Boston', slug: 'boston', population: 685094 },
    { name: 'El Paso', slug: 'el-paso', population: 681728 },
    { name: 'Detroit', slug: 'detroit', population: 639111 },
    { name: 'Nashville', slug: 'nashville', population: 689447 },
    { name: 'Portland', slug: 'portland-or', population: 652503 },
    { name: 'Memphis', slug: 'memphis', population: 651073 },
    { name: 'Oklahoma City', slug: 'oklahoma-city', population: 695755 },
    { name: 'Las Vegas', slug: 'las-vegas', population: 651319 },
    { name: 'Louisville', slug: 'louisville', population: 633045 },
    { name: 'Baltimore', slug: 'baltimore', population: 585708 },
    { name: 'Milwaukee', slug: 'milwaukee', population: 577222 },
    { name: 'Albuquerque', slug: 'albuquerque', population: 564559 },
    { name: 'Tucson', slug: 'tucson', population: 548073 },
    { name: 'Fresno', slug: 'fresno', population: 542107 },
    { name: 'Sacramento', slug: 'sacramento', population: 524943 },
    { name: 'Mesa', slug: 'mesa', population: 518012 },
    { name: 'Kansas City', slug: 'kansas-city-mo', population: 508090 },
    { name: 'Atlanta', slug: 'atlanta', population: 498715 },
    { name: 'Long Beach', slug: 'long-beach', population: 462628 },
    { name: 'Colorado Springs', slug: 'colorado-springs', population: 478961 },
    { name: 'Raleigh', slug: 'raleigh', population: 474069 },
    { name: 'Omaha', slug: 'omaha', population: 486051 },
    { name: 'Miami', slug: 'miami', population: 442241 },
    { name: 'Oakland', slug: 'oakland', population: 433031 },
    { name: 'Minneapolis', slug: 'minneapolis', population: 429954 },
    { name: 'Tulsa', slug: 'tulsa', population: 413066 },
    { name: 'Cleveland', slug: 'cleveland', population: 383793 },
    { name: 'Wichita', slug: 'wichita', population: 397532 },
    { name: 'Arlington', slug: 'arlington-tx', population: 398854 },
    { name: 'New Orleans', slug: 'new-orleans', population: 383997 },
    { name: 'Bakersfield', slug: 'bakersfield', population: 384145 },
    { name: 'Tampa', slug: 'tampa', population: 399700 },
    { name: 'Honolulu', slug: 'honolulu', population: 347397 },
    { name: 'Aurora', slug: 'aurora-co', population: 379289 },
    { name: 'Anaheim', slug: 'anaheim', population: 352497 },
    { name: 'Santa Ana', slug: 'santa-ana', population: 324528 },
    { name: 'St. Louis', slug: 'st-louis', population: 301578 },
    { name: 'Riverside', slug: 'riverside', population: 331254 },
    { name: 'Corpus Christi', slug: 'corpus-christi', population: 326586 },
    { name: 'Lexington', slug: 'lexington', population: 323780 },
    { name: 'Pittsburgh', slug: 'pittsburgh', population: 302971 },
    { name: 'Anchorage', slug: 'anchorage', population: 291247 },
    { name: 'Stockton', slug: 'stockton', population: 310496 },
    { name: 'Cincinnati', slug: 'cincinnati', population: 309317 },
    { name: 'St. Paul', slug: 'st-paul', population: 308096 },
    { name: 'Toledo', slug: 'toledo', population: 287208 },
    { name: 'Greensboro', slug: 'greensboro', population: 296710 },
    { name: 'Newark', slug: 'newark', population: 311549 },
    { name: 'Plano', slug: 'plano', population: 294395 },
    { name: 'Henderson', slug: 'henderson', population: 320189 },
    { name: 'Lincoln', slug: 'lincoln', population: 295178 },
    { name: 'Buffalo', slug: 'buffalo', population: 278349 },
    { name: 'Jersey City', slug: 'jersey-city', population: 292449 },
    { name: 'Chula Vista', slug: 'chula-vista', population: 275487 },
    { name: 'Fort Wayne', slug: 'fort-wayne', population: 270402 },
    { name: 'Orlando', slug: 'orlando', population: 307573 },
    { name: 'St. Petersburg', slug: 'st-petersburg', population: 265351 },
    { name: 'Chandler', slug: 'chandler', population: 261165 },
    { name: 'Laredo', slug: 'laredo', population: 261639 },
    { name: 'Norfolk', slug: 'norfolk', population: 238005 },
    { name: 'Durham', slug: 'durham', population: 283506 },
    { name: 'Madison', slug: 'madison', population: 269840 },
    { name: 'Lubbock', slug: 'lubbock', population: 258862 },
    { name: 'Irvine', slug: 'irvine', population: 287401 },
    { name: 'Winston-Salem', slug: 'winston-salem', population: 249545 },
    { name: 'Glendale', slug: 'glendale-az', population: 248325 },
    { name: 'Garland', slug: 'garland', population: 246018 },
    { name: 'Hialeah', slug: 'hialeah', population: 233394 },
    { name: 'Reno', slug: 'reno', population: 264165 },
    { name: 'Chesapeake', slug: 'chesapeake', population: 249422 },
    { name: 'Gilbert', slug: 'gilbert', population: 267918 },
    { name: 'Baton Rouge', slug: 'baton-rouge', population: 227470 },
    { name: 'Irving', slug: 'irving', population: 256684 },
    { name: 'Scottsdale', slug: 'scottsdale', population: 258069 },
    { name: 'North Las Vegas', slug: 'north-las-vegas', population: 262527 },
    { name: 'Fremont', slug: 'fremont', population: 238537 },
    { name: 'Boise', slug: 'boise', population: 235684 },
    { name: 'Richmond', slug: 'richmond', population: 230436 },
    { name: 'San Bernardino', slug: 'san-bernardino', population: 222101 },
    { name: 'Birmingham', slug: 'birmingham', population: 200733 },
    { name: 'Spokane', slug: 'spokane', population: 230176 },
    { name: 'Rochester', slug: 'rochester', population: 211328 },
    { name: 'Des Moines', slug: 'des-moines', population: 214133 },
    { name: 'Modesto', slug: 'modesto', population: 218464 },
    { name: 'Fayetteville', slug: 'fayetteville', population: 209468 },
    { name: 'Tacoma', slug: 'tacoma', population: 219346 },
    { name: 'Oxnard', slug: 'oxnard', population: 208176 },
    { name: 'Fontana', slug: 'fontana', population: 215791 },
    { name: 'Columbus', slug: 'columbus-ga', population: 206922 },
    { name: 'Montgomery', slug: 'montgomery', population: 200603 },
    ...unitedStatesAdditionalCities,
    ...unitedStatesAdditionalCities2,
    ...unitedStatesAdditionalCities3
  ]
};
